export const MensagensSucessoProposta = {
  comum: 'Proposta gerada com sucesso! ',
  multipla: 'Propostas Agendadas para Geração! '
}
